// Field configs for generic CRUD resources. type: text|number|currency|date|select|textarea
export const RESOURCES = {
  suppliers: {
    title: "Fornitori e imprese", singular: "Fornitore", endpoint: "suppliers",
    columns: ["codice", "ragione_sociale", "tipologia", "partita_iva", "referente", "telefono", "stato"],
    fields: [
      { k: "ragione_sociale", l: "Ragione sociale", req: true },
      { k: "tipologia", l: "Tipologia", type: "select", opts: ["impresa edile", "impiantista", "serramentista", "falegname", "progettista", "geometra", "notaio", "agenzia", "consulente", "fornitore materiali", "altro"] },
      { k: "partita_iva", l: "Partita IVA" },
      { k: "codice_fiscale", l: "Codice fiscale" },
      { k: "indirizzo", l: "Indirizzo" },
      { k: "cap", l: "CAP" },
      { k: "comune", l: "Comune" },
      { k: "provincia", l: "Provincia" },
      { k: "referente", l: "Referente" },
      { k: "telefono", l: "Telefono" },
      { k: "email", l: "Email" },
      { k: "pec", l: "PEC" },
      { k: "codice_sdi", l: "Codice SDI" },
      { k: "iban", l: "IBAN" },
      { k: "durc_scadenza", l: "Scadenza DURC (gestibile anche in 'Scadenze e DURC')", type: "date" },
      { k: "visura_scadenza", l: "Scadenza visura camerale", type: "date" },
      { k: "is_subappaltatore", l: "È un subappaltatore", type: "bool" },
      { k: "appaltatore_id", l: "Impresa appaltatrice principale (se subappaltatore)", type: "ref", ref: "suppliers", refLabel: "ragione_sociale" },
      { k: "valutazione", l: "Valutazione (1-5)", type: "number" },
      { k: "da_completare", l: "Anagrafica da completare (creata automaticamente da fattura)", type: "bool" },
      { k: "preferito", l: "Fornitore preferito (gli agenti lo propongono per primo negli ordini)", type: "bool" },
      { k: "categorie_fornitura", l: "Cosa fornisce (parole separate da virgola: es. cemento, ferramenta, idraulica, cartongesso)" },
      { k: "modalita_ordine", l: "Come si ordina", type: "select", opts: ["sito web", "email", "telefono", "in negozio", "portale B2B", "WhatsApp"] },
      { k: "sito_web", l: "Sito web / portale ordini" },
      { k: "consegna_in_cantiere", l: "Consegna in cantiere", type: "bool" },
      { k: "note_ordine", l: "Note per ordinare (codice cliente, orari, minimi d'ordine, pagamento)", type: "textarea" },
      { k: "stato", l: "Stato", type: "select", opts: ["attivo", "sospeso", "cessato", "in valutazione"] },
      { k: "note", l: "Note", type: "textarea" },
    ],
  },
  orders: {
    title: "Contratti d'appalto e ordini", singular: "Ordine", endpoint: "orders",
    columns: ["codice", "numero", "data:date", "tipo", "supplier_id", "operation_id", "importo:cur", "stato"],
    fields: [
      { k: "tipo", l: "Tipo", type: "select", opts: ["contratto d'appalto", "ordine", "fornitura", "incarico professionale", "subappalto"] },
      { k: "numero", l: "Numero / riferimento" },
      { k: "data", l: "Data", type: "date" },
      { k: "supplier_id", l: "Fornitore / impresa", type: "ref", ref: "suppliers", refLabel: "ragione_sociale", req: true },
      { k: "operation_id", l: "Operazione", type: "ref", ref: "operations", refLabel: "nome_operazione", req: true },
      { k: "gruppo_operation_id", l: "Per cantiere di un'altra società del gruppo (intercompany: es. costo Saircos GC → operazione Capital Stone)", type: "ref", ref: "operations", refLabel: "nome_operazione" },
      { k: "company_id", l: "Società committente", type: "ref", ref: "companies", refLabel: "denominazione" },
      { k: "oggetto", l: "Oggetto dei lavori / fornitura", req: true },
      { k: "importo", l: "Importo contrattuale (imponibile)", type: "currency", req: true },
      { k: "aliquota_iva", l: "Aliquota IVA %", type: "number" },
      { k: "ritenuta_garanzia_pct", l: "Ritenuta a garanzia %", type: "number" },
      { k: "data_inizio", l: "Inizio lavori", type: "date" },
      { k: "data_fine_prevista", l: "Fine lavori prevista", type: "date" },
      { k: "penale_giornaliera", l: "Penale giornaliera ritardo", type: "currency" },
      { k: "stato", l: "Stato", type: "select", opts: ["bozza", "firmato", "in corso", "sospeso", "completato", "annullato"] },
      { k: "note", l: "Note / clausole", type: "textarea" },
    ],
  },
  companies: {
    title: "Società", singular: "Società", endpoint: "companies",
    columns: ["codice", "denominazione", "forma_giuridica", "partita_iva", "stato"],
    fields: [
      { k: "denominazione", l: "Denominazione", req: true },
      { k: "forma_giuridica", l: "Forma giuridica", type: "select", opts: ["SRL", "SPA", "SAS", "SNC", "Ditta individuale"] },
      { k: "codice_fiscale", l: "Codice fiscale" },
      { k: "partita_iva", l: "Partita IVA" },
      { k: "sede_legale", l: "Sede legale" },
      { k: "pec", l: "PEC" },
      { k: "codice_sdi", l: "Codice SDI" },
      { k: "banca", l: "Banca" },
      { k: "iban", l: "IBAN" },
      { k: "amministratore", l: "Amministratore" },
      { k: "capitale_sociale", l: "Capitale sociale", type: "currency" },
      { k: "is_holding", l: "È la holding (capogruppo)", type: "bool" },
      { k: "parent_company_id", l: "Controllata da (società madre)", type: "ref", ref: "companies", refLabel: "denominazione" },
      { k: "rea", l: "REA / CCIAA" },
      { k: "ateco", l: "Attività ATECO" },
      { k: "data_costituzione", l: "Data costituzione", type: "date" },
      { k: "soci", l: "Soci e quote" },
      { k: "sede_secondaria", l: "Sede secondaria / unità locale" },
      { k: "data_inizio_contabilita", l: "Data inizio contabilità in Capital Control", type: "date" },
      { k: "stato", l: "Stato", type: "select", opts: ["attiva", "sospesa", "cessata"] },
      { k: "note", l: "Note", type: "textarea" },
    ],
  },
  operations: {
    title: "Operazioni Immobiliari", singular: "Operazione", endpoint: "operations",
    columns: ["codice", "nome_operazione", "comune", "stato", "prezzo_acquisto:cur", "costi_accessori_previsti:cur", "costo_totale_previsto:cur", "ricavi_previsti:cur", "margine_previsto:cur", "margine_netto_previsto:cur", "roi_previsto:pct", "roe_previsto:pct"],
    fields: [
      { k: "nome_operazione", l: "Nome operazione", req: true },
      { k: "company_id", l: "Società proprietaria", type: "ref", ref: "companies", refLabel: "denominazione" },
      { k: "gc_company_id", l: "General contractor — società del gruppo a cui sono appaltati i lavori (es. Saircos): abilita la fattura intercompany", type: "ref", ref: "companies", refLabel: "denominazione" },
      { k: "descrizione", l: "Descrizione", type: "textarea" },
      { k: "indirizzo", l: "Indirizzo" },
      { k: "comune", l: "Comune" },
      { k: "provincia", l: "Provincia" },
      { k: "cap", l: "CAP" },
      { k: "tipologia", l: "Tipologia", type: "select", opts: ["residenziale", "commerciale", "misto", "terreno", "industriale"] },
      { k: "stato", l: "Stato", type: "select", opts: ["idea", "analisi", "trattativa", "due diligence", "proposta", "preliminare", "acquistata", "progettazione", "cantiere da avviare", "cantiere attivo", "fine lavori", "in vendita", "parzialmente venduta", "venduta", "chiusura amministrativa", "conclusa", "sospesa", "annullata"] },
      { k: "priorita", l: "Priorità", type: "select", opts: ["alta", "media", "bassa"] },
      { k: "avanzamento", l: "Avanzamento %", type: "number" },
      { k: "data_apertura", l: "Data apertura", type: "date" },
      { k: "data_rogito_acquisto", l: "Data rogito acquisto", type: "date" },
      { k: "data_prevista_vendita", l: "Data prevista vendita", type: "date" },
      { k: "prezzo_acquisto", l: "Prezzo acquisto", type: "currency" },
      { k: "imposte_acquisto", l: "Imposte acquisto", type: "currency" },
      { k: "provvigioni_acquisto", l: "Provvigioni acquisto", type: "currency" },
      { k: "costo_tecnico", l: "Costo tecnico", type: "currency" },
      { k: "costo_lavori_previsto", l: "Costo lavori previsto (budget cantiere)", type: "currency" },
      { k: "data_inizio_lavori", l: "Data inizio lavori", type: "date" },
      { k: "data_fine_lavori_prevista", l: "Data fine lavori prevista", type: "date" },
      { k: "costo_arredi_previsto", l: "Costo arredi previsto", type: "currency" },
      { k: "costo_finanziario_previsto", l: "Costo finanziario", type: "currency" },
      { k: "altri_costi_previsti", l: "Altri costi", type: "currency" },
      { k: "ricavi_previsti", l: "Ricavi previsti", type: "currency" },
      { k: "capitale_proprio", l: "Capitale proprio", type: "currency" },
      { k: "capitale_investitori", l: "Capitale da associati — obiettivo (il valore effettivo è la somma degli apporti versati nei contratti)", type: "currency" },
      { k: "finanziamento_bancario", l: "Finanziamento bancario", type: "currency" },
      { k: "livello_rischio", l: "Livello di rischio", type: "select", opts: ["basso", "medio", "alto"] },
      { k: "amministratore_condominio", l: "Amministratore di condominio (nome / studio)" },
      { k: "amministratore_condominio_telefono", l: "Amministratore di condominio — telefono" },
      { k: "amministratore_condominio_email", l: "Amministratore di condominio — email (per richiedere la liberatoria spese)" },
      { k: "note", l: "Note", type: "textarea" },
    ],
    computed: ["costo_totale_previsto", "costo_totale_effettivo", "ricavi_effettivi", "margine_previsto", "margine_effettivo", "roi_previsto", "roi_effettivo", "copertura_finanziaria", "fabbisogno_residuo", "disponibilita_operazione"],
  },
  investors: {
    title: "Associati in partecipazione", singular: "Associato", endpoint: "investors",
    columns: ["codice", "nome", "cognome", "email", "capitale_disponibile:cur", "stato"],
    fields: [
      { k: "tipo", l: "Tipo", type: "select", opts: ["persona_fisica", "societa"] },
      { k: "nome", l: "Nome", req: true },
      { k: "cognome", l: "Cognome" },
      { k: "ragione_sociale", l: "Ragione sociale" },
      { k: "codice_fiscale", l: "Codice fiscale" },
      { k: "partita_iva", l: "Partita IVA" },
      { k: "email", l: "Email" },
      { k: "pec", l: "PEC" },
      { k: "telefono", l: "Telefono" },
      { k: "indirizzo", l: "Indirizzo" },
      { k: "iban", l: "IBAN" },
      { k: "banca", l: "Banca" },
      { k: "capitale_disponibile", l: "Capitale disponibile dichiarato", type: "currency" },
      { k: "stato", l: "Stato", type: "select", opts: ["potenziale", "interessato", "da qualificare", "attivo", "inattivo", "da ricontattare", "sospeso", "concluso"] },
      { k: "livello_rischio", l: "Livello di rischio", type: "select", opts: ["basso", "medio", "alto"] },
      { k: "note", l: "Note", type: "textarea" },
    ],
  },
  investments: {
    title: "Contratti di associazione in partecipazione", singular: "Contratto AIP", endpoint: "investments",
    columns: ["codice", "investor_id", "operation_id", "capitale_versato:cur", "rendimento_previsto:cur", "importo_totale_dovuto:cur", "stato"],
    fields: [
      { k: "investor_id", l: "Associato", type: "ref", ref: "investors", refLabel: "nome", req: true },
      { k: "operation_id", l: "Operazione", type: "ref", ref: "operations", refLabel: "nome_operazione", req: true },
      { k: "company_id", l: "Società associante / emittente (se vuoto: la società dell'operazione)", type: "ref", ref: "companies", refLabel: "denominazione" },
      { k: "tipo_contratto", l: "Tipo di contratto", type: "select", opts: ["associazione in partecipazione (art. 2549 c.c.)", "strumento finanziario partecipativo - SFP (art. 2346 c.c.)"] },
      { k: "data_sottoscrizione", l: "Data sottoscrizione", type: "date" },
      { k: "data_versamento_effettiva", l: "Data versamento effettiva", type: "date" },
      { k: "capitale_promesso", l: "Apporto sottoscritto (uso interno, non compare nei report)", type: "currency" },
      { k: "capitale_versato", l: "Apporto versato", type: "currency" },
      { k: "tipo_rendimento", l: "Tipo quota utili", type: "select", opts: ["importo_fisso", "partecipazione_utile"] },
      { k: "rendimento_concordato", l: "Quota utili concordata: € se importo fisso, % dell'utile dell'operazione se partecipazione (mai % sull'apporto)", type: "number" },
      { k: "durata_prevista", l: "Durata prevista (mesi)", type: "number" },
      { k: "data_scadenza_prevista", l: "Data scadenza prevista", type: "date" },
      { k: "capitale_da_rimborsare", l: "Apporto da restituire", type: "currency" },
      { k: "capitale_rimborsato", l: "Apporto restituito", type: "currency" },
      { k: "rendimento_maturato", l: "Quota utili maturata (si valorizza automaticamente alla chiusura dell'operazione)", type: "currency" },
      { k: "rendimento_pagato", l: "Quota utili pagata", type: "currency" },
      { k: "ritenuta_pct", l: "Ritenuta fiscale % sulla quota utili (26 = persona fisica, 0 = società/reinvestimento)", type: "number" },
      { k: "ritenuta_riportata", l: "Ritenuta riportata da utili reinvestiti in precedenza € (si applica al primo bonifico)", type: "currency" },
      { k: "ritenuta_applicata", l: "Ritenuta trattenuta al bonifico (principio di cassa)", type: "bool" },
      { k: "ritenuta_importo", l: "Ritenuta trattenuta €", type: "currency" },
      { k: "ritenuta_versata", l: "Ritenuta versata con F24 €", type: "currency" },
      { k: "f24_data_versamento", l: "Data versamento F24 (entro il 16 del mese successivo al bonifico)", type: "date" },
      { k: "reinvestimento_da_operazione", l: "Apporto proveniente da reinvestimento dell'operazione", type: "ref", ref: "operations", refLabel: "nome_operazione" },
      { k: "reinvestito_in_operazione", l: "Capitale + utili reinvestiti nell'operazione (nessun bonifico, ritenuta rinviata)", type: "ref", ref: "operations", refLabel: "nome_operazione" },
      { k: "stato", l: "Stato", type: "select", opts: ["bozza", "proposto", "in approvazione", "contratto da firmare", "firmato", "in attesa versamento", "parzialmente versato", "attivo", "in maturazione", "da rimborsare", "parzialmente rimborsato", "concluso", "sospeso", "annullato"] },
      { k: "visibile_portale", l: "Visibile nel portale associati", type: "bool" },
      { k: "note", l: "Note", type: "textarea" },
    ],
    computed: ["capitale_residuo_da_versare", "rendimento_previsto", "importo_totale_dovuto", "ritenuta_prevista", "netto_da_bonificare", "ritenuta_da_versare"],
  },
  accounts: {
    title: "Conti Finanziari", singular: "Conto", endpoint: "accounts",
    columns: ["codice", "nome_conto", "tipologia", "saldo_contabile:cur", "saldo_disponibile:cur", "disponibilita_totale:cur"],
    fields: [
      { k: "nome_conto", l: "Nome conto", req: true },
      { k: "company_id", l: "Società", type: "ref", ref: "companies", refLabel: "denominazione" },
      { k: "banca", l: "Banca" },
      { k: "iban", l: "IBAN" },
      { k: "tipologia", l: "Tipologia", type: "select", opts: ["conto corrente", "carta", "cassa contanti", "conto deposito", "conto vincolato", "conto finanziamento", "conto soci", "altro"] },
      { k: "saldo_iniziale", l: "Saldo iniziale", type: "currency" },
      { k: "affidamento", l: "Affidamento", type: "currency" },
      { k: "attivo", l: "Attivo", type: "bool" },
      { k: "note", l: "Note", type: "textarea" },
    ],
  },
  movements: {
    title: "Movimenti di Cassa", singular: "Movimento", endpoint: "movements",
    columns: ["codice", "data_pagamento:date", "descrizione", "category", "importo:cur", "direction", "stato"],
    fields: [
      { k: "direction", l: "Entrata / Uscita", type: "select", opts: ["entrata", "uscita"], req: true },
      { k: "type", l: "Tipo movimento", type: "select", opts: ["entrata", "uscita", "trasferimento_interno", "rettifica", "impegno", "previsione"] },
      { k: "data_competenza", l: "Data competenza", type: "date" },
      { k: "data_pagamento", l: "Data pagamento", type: "date" },
      { k: "company_id", l: "Società", type: "ref", ref: "companies", refLabel: "denominazione" },
      { k: "account_id", l: "Conto finanziario", type: "ref", ref: "accounts", refLabel: "nome_conto", req: true },
      { k: "account_dest_id", l: "Conto destinazione (trasferimenti)", type: "ref", ref: "accounts", refLabel: "nome_conto" },
      { k: "operation_id", l: "Operazione", type: "ref", ref: "operations", refLabel: "nome_operazione" },
      { k: "gruppo_operation_id", l: "Per cantiere di un'altra società del gruppo (intercompany: es. costo Saircos GC → operazione Capital Stone)", type: "ref", ref: "operations", refLabel: "nome_operazione" },
      { k: "budget_item_id", l: "Voce di budget / lavorazione (previsto vs effettivo)", type: "ref", ref: "budget-items", refLabel: "voce" },
      { k: "category", l: "Categoria", type: "select", opts: ["apporto soci", "apporto associato in partecipazione", "investimento ricevuto", "finanziamento bancario", "acconto vendita", "saldo vendita", "caparra", "rimborso", "interessi attivi", "altro ricavo", "acquisto immobile", "imposte", "notaio", "agenzia", "progettazione", "tecnico", "lavori", "materiali", "impianti", "serramenti", "arredi", "fornitore", "consulenza", "assicurazione", "utenze", "marketing", "commissioni bancarie", "interessi passivi", "restituzione apporto associato", "pagamento quota utili associato", "rimborso capitale investitore", "pagamento rendimento investitore", "tasse", "altro costo"] },
      { k: "descrizione", l: "Descrizione" },
      { k: "importo", l: "Importo", type: "currency", req: true },
      { k: "actual", l: "Effettivo (non previsto)", type: "bool" },
      { k: "stato", l: "Stato", type: "select", opts: ["previsto", "autorizzato", "da pagare", "parzialmente pagato", "pagato", "incassato", "scaduto", "annullato"] },
      { k: "metodo_pagamento", l: "Metodo pagamento", type: "select", opts: ["bonifico", "contanti", "assegno", "carta", "RID", "altro"] },
      { k: "riferimento_pagamento", l: "Riferimento pagamento" },
      { k: "note", l: "Note", type: "textarea" },
    ],
  },
};

export const ROLE_LABELS = {
  super_admin: "Super Admin", amministrazione: "Amministrazione", project_manager: "Project Manager",
  responsabile_cantiere: "Responsabile cantiere", investitore: "Associato", sola_lettura: "Sola lettura",
};
